<template>
  <div>
    <div v-if="!disabled" class="col-12">
      <a @click="+status === 1 ? to() : alert()" target="_blank">
        <div
          style="background-color: white"
          class="
              col
              shadow1
              text-left
              br
              d-flex
              flex-row
              align-items-center
              mt-3
              mb-0
              py-2
              px-3
            "
        >
          <img class="imagecustom pr-3" src="../../assets/Promosi.png" alt />

          <div class="align-items-center">
            <h5 class="font14 caption4 p-0 m-0 text-dark font-weight-bold">
              SOLITAIRE
            </h5>
          </div>
          <img
            class="iconcustom ml-auto"
            src="https://i.imgur.com/5qg2kk5.png"
            alt
          />
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },

    status: {
      type: [Number, String],
      default: () => 0
    }
  },

  created() {
    console.log(this.disabled, this.status)
  },

  methods: {
    alert() {
      Swal.fire({
        text: "",
        html:
          '<img src="https://i.ibb.co/jRQKCkM/android-chrome-512x512.png"/> ' +
          "<p>Anda belum terdaftar di program solitare. Informasi lebih lanjut bisa hubungi salesman</p>",

        confirmButtonText: "Tutup"
      });
    },
    to() {
      window.location.href = "https://solitaire2022.inosis.biz/";
    }
  }
};
</script>
<style>
.danger {
  color: red;
}

.shadow1 {
  box-shadow: 0 0.1rem 0.3rem rgba(182, 189, 255, 0.308) !important;
  border: 0.7px solid #dedede;
}

.br {
  border-radius: 15px;
}
</style>
